export default "__VITE_ASSET__u3$z06Jl__"